import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bemGenerator } from '@prisjakt/ui-base';
import { openReviewDialog } from '../../actions';

import './index.scss';

const styles = bemGenerator('product-user-review-prompt', [
  'login-link',
  'first-to-review',
]);

const UserReviewPrompt = props => (
  <div className={styles.block}>
    {props.firstToReview && (
      <p className={styles['first-to-review']}>{props.firstToReviewText}</p>
    )}

    {React.cloneElement(props.control, {
      onClick: () =>
        props.requireLogin
          ? props.history.push('/login')
          : props.openReviewDialog(),
    })}
  </div>
);

const { bool, func, element, string, object } = PropTypes;

UserReviewPrompt.propTypes = {
  control: element.isRequired,
  openReviewDialog: func.isRequired,
  requireLogin: bool,
  firstToReview: bool,
  firstToReviewText: string,
  history: object.isRequired,
};

UserReviewPrompt.defaultProps = {
  requireLogin: false,
  firstToReview: false,
  firstToReviewText: undefined,
};

export default connect(
  state => ({ open: state.areas.review.open }),
  { openReviewDialog }
)(memo(withRouter(UserReviewPrompt)));
